
import { Component, Vue } from "vue-property-decorator";
import ComplianceProfile from "@/modules/Compliance/Profile/ComplianceProfile.vue";
import { SMApp, SMUser } from "@/store";
import { EMPLOYEE_EMPLOYMENT_STATUS_LEAVER } from "@/constants/compliance";

const TYPE_COMPLIANCE_PROFILE_EMPLOYEE = "complianceProfileEmployee";

@Component({
  components: {
    ComplianceProfile,
    NotificationEmployeeTerminated: () =>
      import("@/components/Notifications/NotificationEmployeeTerminated.vue"),
  },
})
export default class Employment extends Vue {
  type = TYPE_COMPLIANCE_PROFILE_EMPLOYEE;

  get isEmployeeTerminated() {
    return SMApp.employeeWorkingStatus === EMPLOYEE_EMPLOYMENT_STATUS_LEAVER;
  }

  get canEdit() {
    if (SMUser.isExpert) return true;

    if (this.isEmployeeTerminated) return false;

    return SMUser.isEmployer;
  }
}
